import * as Sentry from '@sentry/react'
import React from 'react'
import ReactDOM from 'react-dom'

import { App } from './App'

// Start msw worker
if (process.env['NODE_ENV'] === 'development' && process.env['IS_MSW']) {
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  const { worker } = require('./mocks/config/browser')
  worker.start()
}

if (process.env['NODE_ENV'] === 'production') {
  // Start sentry
  Sentry.init({
    dsn: process.env['SENTRY_DSN'],
    integrations: [],
    // tracesSampleRate: 1.0,
  })
}

ReactDOM.render(<App />, document.getElementById('estra-sponsor-app'))

if (module.hot) {
  module.hot.accept()
}
